// authActions.js
export const ACT_AUTH_NO_TOKEN_FOUND = 'ACT_AUTH_NO_TOKEN_FOUND';
export const ACT_AUTH_TOKEN_CHECK = 'ACT_AUTH_TOKEN_CHECK';
export const ACT_FULL_PAGE_LOAD = 'ACT_FULL_PAGE_LOAD';
export const ACT_AUTH_TOKEN_SUCCESS = 'ACT_AUTH_TOKEN_SUCCESS';
export const ACT_AUTH_TOKEN_FAIL = 'ACT_AUTH_TOKEN_FAIL';
export const ACT_AUTH_TOKEN_EMPTY = 'ACT_AUTH_TOKEN_FAIL';
export const ACT_AUTH_LOGIN_FAILED = 'ACT_AUTH_LOGIN_FAILED';
export const ACT_AUTH_LOGIN_ATTEMPT = 'ACT_AUTH_LOGIN_ATTEMPT';
export const ACT_AUTH_LOGIN_SUCCESS = 'ACT_AUTH_LOGIN_SUCCESS';
export const ACT_AUTH_DEL_TOKEN = 'ACT_AUTH_DEL_TOKEN';
export const ACT_AUTH_LOGOUT_INIT = 'ACT_AUTH_LOGOUT_INIT';
export const ACT_AUTH_LOGOUT_SUCCESS = 'ACT_AUTH_LOGOUT_SUCCESS';

// countriesActions.js
export const ACT_COUNTRIES_FETCH_INIT = 'ACT_COUNTRIES_FETCH_INIT';
export const ACT_COUNTRIES_FETCH_200 = 'ACT_COUNTRIES_FETCH_200';
export const ACT_COUNTRIES_ADD_INIT = 'ACT_COUNTRIES_ADD_INIT';
export const ACT_COUNTRIES_ADD_201 = 'ACT_COUNTRIES_ADD_201';
export const ACT_COUNTRIES_ADD_500 = 'ACT_COUNTRIES_ADD_500';
export const ACT_COUNTRIES_DELETE_INIT = 'ACT_COUNTRIES_DELETE_INIT';
export const ACT_COUNTRIES_DELETE_204 = 'ACT_COUNTRIES_DELETE_204';

export const ACT_DYNASTIES_FETCH_INIT = 'ACT_DYNASTIES_FETCH_INIT';
export const ACT_DYNASTIES_FETCH_200 = 'ACT_DYNASTIES_FETCH_200';

export const ACT_TAGS_FETCH_INIT = 'ACT_TAGS_FETCH_INIT';
export const ACT_TAGS_FETCH_200 = 'ACT_TAGS_FETCH_200';

export const ACT_APP_STARTING = 'ACT_APP_STARTING';
export const ACT_APP_STARTED = 'ACT_APP_STARTED';

// components.js
export const ACT_INSTANCES_FETCH_COMPONENTS_INIT_ACTION = 'ACT_INSTANCES_FETCH_COMPONENTS_INIT_ACTION';
export const ACT_INSTANCES_FETCH_COMPONENTS_SUCCESS_ACTION = 'ACT_INSTANCES_FETCH_COMPONENTS_SUCCESS_ACTION';
export const ACT_INSTANCES_GET_COMPONENT_INIT_ACTION = 'ACT_INSTANCES_GET_COMPONENT_INIT_ACTION';
export const ACT_INSTANCES_GET_COMPONENT_SUCCESS_ACTION = 'ACT_INSTANCES_GET_COMPONENT_SUCCESS_ACTION';
export const ACT_INSTANCES_ADD_COMPONENT_INIT_ACTION = 'ACT_INSTANCES_ADD_COMPONENT_INIT_ACTION';
export const ACT_INSTANCES_ADD_COMPONENT_SUCCESS_ACTION = 'ACT_INSTANCES_ADD_COMPONENT_SUCCESS_ACTION';
export const ACT_INSTANCES_DELETE_COMPONENT_INIT_ACTION = 'ACT_INSTANCES_DELETE_COMPONENT_INIT_ACTION';
export const ACT_INSTANCES_DELETE_COMPONENT_SUCCESS_ACTION = 'ACT_INSTANCES_DELETE_COMPONENT_SUCCESS_ACTION';
export const ACT_INSTANCES_UPDATE_COMPONENTS_FILTERS = 'ACT_INSTANCES_UPDATE_COMPONENTS_FILTERS';
export const ACT_INSTANCES_SET_SELECTED_COMPONENT = 'ACT_INSTANCES_SET_SELECTED_COMPONENT';

// elements.js
export const ACT_INSTANCES_FETCH_ELEMENTS_INIT_ACTION = 'ACT_INSTANCES_FETCH_ELEMENTS_INIT_ACTION';
export const ACT_INSTANCES_FETCH_ELEMENTS_SUCCESS_ACTION = 'ACT_INSTANCES_FETCH_ELEMENTS_SUCCESS_ACTION';
export const ACT_INSTANCES_GET_ELEMENT_INIT_ACTION = 'ACT_INSTANCES_GET_ELEMENT_INIT_ACTION';
export const ACT_INSTANCES_GET_ELEMENT_SUCCESS_ACTION = 'ACT_INSTANCES_GET_ELEMENT_SUCCESS_ACTION';
export const ACT_INSTANCES_ADD_ELEMENT_INIT_ACTION = 'ACT_INSTANCES_ADD_ELEMENT_INIT_ACTION';
export const ACT_INSTANCES_ADD_ELEMENT_SUCCESS_ACTION = 'ACT_INSTANCES_ADD_ELEMENT_SUCCESS_ACTION';
export const ACT_INSTANCES_DELETE_ELEMENT_INIT_ACTION = 'ACT_INSTANCES_DELETE_ELEMENT_INIT_ACTION';
export const ACT_INSTANCES_DELETE_ELEMENT_SUCCESS_ACTION = 'ACT_INSTANCES_DELETE_ELEMENT_SUCCESS_ACTION';
export const ACT_INSTANCES_UPDATE_ELEMENTS_FILTERS = 'ACT_INSTANCES_UPDATE_ELEMENTS_FILTERS';
export const ACT_INSTANCES_SET_SELECTED_ELEMENT = 'ACT_INSTANCES_SET_SELECTED_ELEMENT';

// products.js
export const ACT_INSTANCES_FETCH_PRODUCTS_INIT_ACTION = 'ACT_INSTANCES_FETCH_PRODUCTS_INIT_ACTION';
export const ACT_INSTANCES_FETCH_PRODUCTS_SUCCESS_ACTION = 'ACT_INSTANCES_FETCH_PRODUCTS_SUCCESS_ACTION';
export const ACT_INSTANCES_GET_PRODUCT_INIT_ACTION = 'ACT_INSTANCES_GET_PRODUCT_INIT_ACTION';
export const ACT_INSTANCES_GET_PRODUCT_SUCCESS_ACTION = 'ACT_INSTANCES_GET_PRODUCT_SUCCESS_ACTION';
export const ACT_INSTANCES_ADD_PRODUCT_INIT_ACTION = 'ACT_INSTANCES_ADD_PRODUCT_INIT_ACTION';
export const ACT_INSTANCES_ADD_PRODUCT_SUCCESS_ACTION = 'ACT_INSTANCES_ADD_PRODUCT_SUCCESS_ACTION';
export const ACT_INSTANCES_DELETE_PRODUCT_INIT_ACTION = 'ACT_INSTANCES_DELETE_PRODUCT_INIT_ACTION';
export const ACT_INSTANCES_DELETE_PRODUCT_SUCCESS_ACTION = 'ACT_INSTANCES_DELETE_PRODUCT_SUCCESS_ACTION';
export const ACT_INSTANCES_UPDATE_PRODUCTS_FILTERS = 'ACT_INSTANCES_UPDATE_PRODUCTS_FILTERS';
export const ACT_INSTANCES_SET_SELECTED_PRODUCT = 'ACT_INSTANCES_SET_SELECTED_PRODUCT';

// contexts.js
export const ACT_INSTANCES_FETCH_CONTEXTS_INIT_ACTION = 'ACT_INSTANCES_FETCH_CONTEXTS_INIT_ACTION';
export const ACT_INSTANCES_FETCH_CONTEXTS_SUCCESS_ACTION = 'ACT_INSTANCES_FETCH_CONTEXTS_SUCCESS_ACTION';
export const ACT_INSTANCES_GET_CONTEXT_INIT_ACTION = 'ACT_INSTANCES_GET_CONTEXT_INIT_ACTION';
export const ACT_INSTANCES_GET_CONTEXT_SUCCESS_ACTION = 'ACT_INSTANCES_GET_CONTEXT_SUCCESS_ACTION';
export const ACT_INSTANCES_ADD_CONTEXT_INIT_ACTION = 'ACT_INSTANCES_ADD_CONTEXT_INIT_ACTION';
export const ACT_INSTANCES_ADD_CONTEXT_SUCCESS_ACTION = 'ACT_INSTANCES_ADD_CONTEXT_SUCCESS_ACTION';
export const ACT_INSTANCES_DELETE_CONTEXT_INIT_ACTION = 'ACT_INSTANCES_DELETE_CONTEXT_INIT_ACTION';
export const ACT_INSTANCES_DELETE_CONTEXT_SUCCESS_ACTION = 'ACT_INSTANCES_DELETE_CONTEXT_SUCCESS_ACTION';
export const ACT_INSTANCES_UPDATE_CONTEXT_FILTERS = 'ACT_INSTANCES_UPDATE_CONTEXT_FILTERS';
export const ACT_INSTANCES_SET_SELECTED_CONTEXT = 'ACT_INSTANCES_SET_SELECTED_CONTEXT';

// characteristics.js
export const ACT_INSTANCES_FETCH_CHARACTERISTICS_INIT_ACTION = 'ACT_INSTANCES_FETCH_CHARACTERISTICS_INIT_ACTION';
export const ACT_INSTANCES_FETCH_CHARACTERISTICS_SUCCESS_ACTION = 'ACT_INSTANCES_FETCH_CHARACTERISTICS_SUCCESS_ACTION';
export const ACT_INSTANCES_GET_CHARACTERISTIC_INIT_ACTION = 'ACT_INSTANCES_GET_CHARACTERISTIC_INIT_ACTION';
export const ACT_INSTANCES_GET_CHARACTERISTIC_SUCCESS_ACTION = 'ACT_INSTANCES_GET_CHARACTERISTIC_SUCCESS_ACTION';
export const ACT_INSTANCES_ADD_CHARACTERISTIC_INIT_ACTION = 'ACT_INSTANCES_ADD_CHARACTERISTIC_INIT_ACTION';
export const ACT_INSTANCES_ADD_CHARACTERISTIC_SUCCESS_ACTION = 'ACT_INSTANCES_ADD_CHARACTERISTIC_SUCCESS_ACTION';
export const ACT_INSTANCES_DELETE_CHARACTERISTIC_INIT_ACTION = 'ACT_INSTANCES_DELETE_CHARACTERISTIC_INIT_ACTION';
export const ACT_INSTANCES_DELETE_CHARACTERISTIC_SUCCESS_ACTION = 'ACT_INSTANCES_DELETE_CHARACTERISTIC_SUCCESS_ACTION';
export const ACT_INSTANCES_UPDATE_CHARACTERISTIC_FILTERS = 'ACT_INSTANCES_UPDATE_CHARACTERISTIC_FILTERS';
export const ACT_INSTANCES_SET_SELECTED_CHARACTERISTIC = 'ACT_INSTANCES_SET_SELECTED_CHARACTERISTIC';

// buildings.js
export const ACT_INSTANCES_FETCH_BUILDINGS_INIT_ACTION = 'ACT_INSTANCES_FETCH_BUILDINGS_INIT_ACTION';
export const ACT_INSTANCES_FETCH_BUILDINGS_SUCCESS_ACTION = 'ACT_INSTANCES_FETCH_BUILDINGS_SUCCESS_ACTION';
export const ACT_INSTANCES_FILTER_BUILDINGS_INIT_ACTION = 'ACT_INSTANCES_FILTER_BUILDINGS_INIT_ACTION';
export const ACT_INSTANCES_FILTER_BUILDINGS_SUCCESS_ACTION = 'ACT_INSTANCES_FILTER_BUILDINGS_SUCCESS_ACTION';
export const ACT_INSTANCES_UPDATE_MAIN_BUILDINGS_FILTERS_ACTION = 'ACT_INSTANCES_UPDATE_MAIN_BUILDINGS_FILTERS_ACTION';
export const ACT_INSTANCES_SET_SELECTED_BUILDING = 'ACT_INSTANCES_SET_SELECTED_BUILDING';
export const ACT_INSTANCES_SET_BUILDINGS_PAGE_INFO = 'ACT_INSTANCES_SET_BUILDINGS_PAGE_INFO';

// usersActions.js
export const ACT_USERS_FETCH_INIT = 'ACT_USERS_FETCH_INIT';
export const ACT_USERS_FETCH_200 = 'ACT_USERS_FETCH_200';
export const ACT_UPDATE_SELECTED_USER = 'ACT_UPDATE_SELECTED_USER';
